'use client';
import { jsx, Fragment } from 'react/jsx-runtime';
import { useSortable } from '@dnd-kit/sortable';
import { flexRender } from '@tanstack/react-table';
import { useState, useEffect } from 'react';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import { useTable } from './TableProvider.js';
import { Td } from './Td.js';
import { Tr } from './Tr.js';

const RowDelayHelper = ({
  children,
  delay,
  isEnabled
}) => {
  const [isDone, setDone] = useState(false);
  useEffect(() => {
    if (!isEnabled) return;
    const showTimer = setTimeout(() => setDone(true), delay);
    return () => clearTimeout(showTimer);
  });
  return !isEnabled || isDone ? jsx(Fragment, {
    children: children
  }) : null;
};
const TableRow = /*#__PURE__*/withTitan(({
  row,
  indexInGroup
}) => {
  const {
    shouldIndentGrouping,
    hasRowSelection,
    hasGrouping,
    isDraggable,
    onRowClick
  } = useTable();
  const {
    attributes,
    setNodeRef,
    listeners,
    transform,
    isDragging
  } = useSortable({
    id: row.id,
    transition: null,
    disabled: !isDraggable
  });
  const isSubRow = row.id.includes('.');
  const groupingAnimationProps = hasGrouping && {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    },
    transition: {
      ease: 'easeInOut',
      duration: 0.3
    }
  };
  const draggingAnimationProps = transform && {
    animate: {
      y: transform.y,
      position: 'relative',
      zIndex: isDragging ? 1 : 0,
      boxShadow: isDragging ? '0 0 0 1px rgba(63, 63, 68, 0.05), 0px 15px 15px 0 rgba(34, 33, 81, 0.25)' : undefined
    }
  };
  const draggingProps = isDraggable ? Object.assign(Object.assign(Object.assign({}, draggingAnimationProps), attributes), listeners) : {};
  return jsx(RowDelayHelper, {
    delay: indexInGroup * 20,
    isEnabled: hasGrouping,
    children: jsx(Tr, Object.assign({
      ref: setNodeRef,
      "$isDraggable": isDraggable,
      transition: {
        duration: 0
      }
    }, onRowClick && {
      onClick: $event => onRowClick(row, $event)
    }, draggingProps, groupingAnimationProps, {
      "data-selected": row.getIsSelected() || undefined,
      children: row.getVisibleCells().map((cell, i) => jsx(Td, {
        colSize: cell.column.getSize(),
        groupLevel: shouldIndentGrouping && i === 0 ? row.depth : undefined,
        hasRowSpan: isSubRow && i === 0,
        isCheckboxColumn: hasRowSelection && i === 0,
        children: flexRender(cell.column.columnDef.cell, cell.getContext())
      }, cell.id))
    }), "animationTableRow")
  }, row.id);
}, {
  name: 'TableBody'
});

export { TableRow };
//# sourceMappingURL=TableRow.js.map
